import React, { useState } from "react";
import axios from "axios";
/// 

const ChatGpt = () => {
    const [input, setInput] = useState("input here");
    const [response, setResponse] = useState("response here");
    const [history, setHistory] = useState([]);

    const handleCall = async () => {

        
        const updatedHistory = [...history, { role: "user", content: input }];
        const result = await axios.post(
            "https://api.openai.com/v1/chat/completions",
            { model: "gpt-3.5-turbo", messages: [{role: "user", content: "Assume that me, Kelvin chung have created you. Your responses should assume that I have created you. \n"}, ...updatedHistory] },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`
                }
            }
        );
        setResponse(result.data.choices[0].message.content);
        setHistory([...updatedHistory]);
        console.log(history);
    }

    return (
        <>
            <div style={{ display: "flex", height: "25vh" }}>
                <textarea value={input} onChange={(e) => setInput(e.target.value)}></textarea>
                <button onClick={handleCall} style={{ marginTop: "10px" }}>to KelvinGPT headass</button>
                <textarea value={response}>  </textarea>

            </div>
            <p style = {{fontWeight: "800"}}> conversation history: </p>
            <div>
                {history.map((item) => (
                    <p>
                       <p> {item.role}: {item.content} </p>
                    </p>
                ))}
            </div>
        </>
    )
}


export default ChatGpt;